var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Box, Typography, Stack, Button, Checkbox, IconButton, Grid, FormControl, Select, MenuItem, Modal, TextField as MuiTextField, InputAdornment, CircularProgress, } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { BackArrowIcon, CustomerPortalUsermanagementIcon, } from "../../components/icons";
import ModuleTable from "../../components/UtilityComponents/moduleTable";
import { CustomerPortalUserManagementCols, CustomerPortalUserNotificationCols, } from "../../config/TableColumns";
import CommonHeader from "../../components/UtilityComponents/commonHeader";
import SearchField from "../../components/FormComponents/SearchField";
import DrawerComponent from "../../components/uiComponents/DrawerComponent";
import TextField from "../../components/FormComponents/TextField";
import MUIDatePicker from "../../components/FormComponents/DatePicker";
import { api_service } from "../../api/api_service";
import { api_urls } from "../../api/api_urls";
import { utility } from "../../utils";
import constants from "../../config/constants";
import moment from "moment";
import ConfirmationAndInformationPoup, { POPUP_TYPE, } from "../../components/UtilityComponents/ConfirmationAndInformationPoup";
import { colors } from "../../Themes/colors";
import CommonTablePagination from "../../components/UtilityComponents/commonTablePagination";
import { getCustomerPortalDisplayName, sortCustomerPortals, validateDate, validateNameField, sanitizeNameFieldInput, maskPhoneNumber, getPhoneActionLabel, } from "../../utils/commonUtilities";
import useCustomerPortalPermissions from "../../hooks/useCustomerPortalPermissions";
var isValidPhoneDigits = function (phone) {
    return /^\d{10}$/.test(phone || "");
};
var PHONE_EXTENSION = "+1";
var maskPhoneDigits = function (phone) {
    if (!phone)
        return "";
    return phone.length <= 4
        ? phone
        : "•".repeat(phone.length - 4) + phone.slice(-4);
};
var CustomerPortalUserManagement = function () {
    var _a, _b, _c;
    var location = useLocation();
    var _d = useState("list"), viewMode = _d[0], setViewMode = _d[1];
    var _e = useState(""), searchText = _e[0], setSearchText = _e[1];
    var _f = useState(false), associateDrawerOpen = _f[0], setAssociateDrawerOpen = _f[1];
    var _g = useState(null), selectedUser = _g[0], setSelectedUser = _g[1];
    var _h = useState(""), associateSearchText = _h[0], setAssociateSearchText = _h[1];
    var _j = useState([]), searchedUsers = _j[0], setSearchedUsers = _j[1];
    var _k = useState([]), selectedUserForContracts = _k[0], setSelectedUserForContracts = _k[1];
    var _l = useState([]), contracts = _l[0], setContracts = _l[1];
    var _m = useState([]), selectedContractIds = _m[0], setSelectedContractIds = _m[1];
    var _o = useState(false), isSearchingUsers = _o[0], setIsSearchingUsers = _o[1];
    var cpPermissions = useCustomerPortalPermissions();
    var todayDate = moment().format("YYYY-MM-DD");
    var weeklyFromDate = moment().subtract(6, "days").format("YYYY-MM-DD");
    var _p = useState(weeklyFromDate), fromDate = _p[0], setFromDate = _p[1];
    var _q = useState(todayDate), toDate = _q[0], setToDate = _q[1];
    var _r = useState(""), fromDateError = _r[0], setFromDateError = _r[1];
    var _s = useState(""), toDateError = _s[0], setToDateError = _s[1];
    var _t = useState(false), editDrawerOpen = _t[0], setEditDrawerOpen = _t[1];
    var _u = useState(false), viewDrawerOpen = _u[0], setViewDrawerOpen = _u[1];
    var _v = useState(null), phoneVerifyModal = _v[0], setPhoneVerifyModal = _v[1];
    var _w = useState(false), rowDataScreen = _w[0], setRowDataScreen = _w[1];
    var _x = useState(null), selectedUserId = _x[0], setSelectedUserId = _x[1];
    var _y = useState(null), detailRow = _y[0], setDetailRow = _y[1];
    var _z = useState(null), userName = _z[0], setUserName = _z[1];
    var _0 = useState(null), userEmail = _0[0], setUserEmail = _0[1];
    var _1 = useState(null), userCustomerId = _1[0], setUserCustomerId = _1[1];
    var _2 = useState(null), userPhone = _2[0], setUserPhone = _2[1];
    var _3 = useState(false), userPhoneVerified = _3[0], setUserPhoneVerified = _3[1];
    var _4 = useState({
        FirstName: "",
        LastName: "",
        Email: "",
        phoneNumbers: [],
        Status: "",
        RegisteredOn: "",
    }), userFormData = _4[0], setUserFormData = _4[1];
    var _5 = useState(false), statusConfirmationOpen = _5[0], setStatusConfirmationOpen = _5[1];
    var _6 = useState(null), pendingStatusUpdate = _6[0], setPendingStatusUpdate = _6[1];
    var _7 = useState([]), users = _7[0], setUsers = _7[1];
    var _8 = useState(false), isLoading = _8[0], setIsLoading = _8[1];
    var _9 = useState(1), currentPage = _9[0], setCurrentPage = _9[1];
    var _10 = useState(50), recordsPerPage = _10[0], setRecordsPerPage = _10[1];
    var _11 = useState(0), totalCount = _11[0], setTotalCount = _11[1];
    var _12 = useState(1), notificationCurrentPage = _12[0], setNotificationCurrentPage = _12[1];
    var _13 = useState(10), notificationRecordsPerPage = _13[0], setNotificationRecordsPerPage = _13[1];
    var _14 = useState(false), showInactiveOnly = _14[0], setShowInactiveOnly = _14[1];
    var _15 = useState(null), selctedPortal = _15[0], setSelectedPortal = _15[1];
    var _16 = useState([]), brands = _16[0], setBrands = _16[1];
    var _17 = useState(false), isContractChecked = _17[0], setIsContractChecked = _17[1];
    var _18 = useState({ FirstName: "", LastName: "" }), editFormErrors = _18[0], setEditFormErrors = _18[1];
    var _19 = useState(null), userNotificationData = _19[0], setUserNotificationData = _19[1];
    var _20 = useState([]), userContractData = _20[0], setUserContractData = _20[1];
    var _21 = useState([]), selectedUserContractIds = _21[0], setSelectedUserContractIds = _21[1];
    var transformUserData = function (apiUsers) {
        return apiUsers.map(function (user) {
            var _a;
            return (__assign(__assign({}, user), { Name: user.Name, Email: user.Email, AspireId: (_a = user.AspireId) !== null && _a !== void 0 ? _a : "-", CreatedTime: user.CreatedTime, Status: user.Status, PhoneNumber: user.PhoneNumber, IsPhoneVerified: user.IsPhoneVerified }));
        });
    };
    var fetchUsers = function (page, limit) {
        if (page === void 0) { page = 1; }
        if (limit === void 0) { limit = 10; }
        return __awaiter(void 0, void 0, void 0, function () {
            var response, apiResponse, transformedData, error_1, errorMessage;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        setIsLoading(true);
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, 4, 5]);
                        return [4, api_service.get({
                                endPoint: api_urls.CUSTOMER_PORTAL_USER_LIST,
                                payLoad: __assign(__assign(__assign({ page: page, limit: limit }, (searchText && { search: searchText })), (showInactiveOnly && { status: 0 })), { portalId: selctedPortal }),
                                showLoader: true,
                            })];
                    case 2:
                        response = _d.sent();
                        if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                            apiResponse = response.data;
                            transformedData = transformUserData(apiResponse.data);
                            setUsers(transformedData);
                            setTotalCount(apiResponse.totalCount != null && apiResponse.totalCount >= 0
                                ? apiResponse.totalCount
                                : transformedData.length);
                        }
                        else {
                            utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to fetch users", constants.TOAST_TYPES.ERROR);
                        }
                        return [3, 5];
                    case 3:
                        error_1 = _d.sent();
                        console.error("Error fetching users:", error_1);
                        errorMessage = ((_c = (_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                            (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) ||
                            "Failed to fetch users";
                        utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                        return [3, 5];
                    case 4:
                        setIsLoading(false);
                        return [7];
                    case 5: return [2];
                }
            });
        });
    };
    var fetchBrands = function (cancelToken) { return __awaiter(void 0, void 0, void 0, function () {
        var response, brandsData, error_2, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4, api_service.get({
                            endPoint: api_urls.CUSTOMER_PORTAL_BRAND_LIST,
                            payLoad: {},
                            showLoader: true,
                            cancelToken: cancelToken,
                        })];
                case 1:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        brandsData = sortCustomerPortals(response.data.data || []);
                        setBrands(brandsData);
                        if (brandsData.length > 0 && !selctedPortal) {
                            setSelectedPortal(Number(brandsData[0].Id));
                        }
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to fetch brands", constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 3];
                case 2:
                    error_2 = _d.sent();
                    if (axios.isCancel(error_2))
                        return [2];
                    console.error("Error fetching brands:", error_2);
                    errorMessage = ((_c = (_b = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_2 === null || error_2 === void 0 ? void 0 : error_2.message) ||
                        "Failed to fetch brands";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    useEffect(function () {
        fetchBrands();
    }, [location.key]);
    useEffect(function () {
        if (selctedPortal) {
            fetchUsers(currentPage, recordsPerPage);
        }
    }, [
        currentPage,
        recordsPerPage,
        searchText,
        showInactiveOnly,
        selctedPortal,
    ]);
    var handleViewModeChange = function (event, newViewMode) {
        if (newViewMode !== null) {
            setViewMode(newViewMode);
        }
    };
    var handleCreateUser = function () {
        console.log("Create user clicked");
    };
    var handleSearch = function (searchValue) {
        setSearchText(searchValue);
        setCurrentPage(1);
    };
    var updateUserStatus = function (userId, userData) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, error_3, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    payload = {
                        userId: userId,
                        status: userData.Status,
                    };
                    return [4, api_service.patch({
                            endPoint: "".concat(api_urls.CUSTOMER_PORTAL_UPDATE_USER_STATUS),
                            payLoad: payload,
                            showLoader: true,
                        })];
                case 1:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        utility.alert(response.data.message || "User updated successfully!", constants.TOAST_TYPES.INFO);
                        fetchUsers(currentPage, recordsPerPage);
                        return [2, response.data];
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to update user", constants.TOAST_TYPES.ERROR);
                        return [2, null];
                    }
                    return [3, 3];
                case 2:
                    error_3 = _d.sent();
                    console.error("Error updating user:", error_3);
                    errorMessage = ((_c = (_b = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_3 === null || error_3 === void 0 ? void 0 : error_3.message) ||
                        "Failed to update user";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [2, null];
                case 3: return [2];
            }
        });
    }); };
    var fetchUserContractData = function (userId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, apiResponse, rawData, contracts_1, allContractIds, error_4, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, 3, 4]);
                    return [4, api_service.get({
                            endPoint: "".concat(api_urls.CUSTOMER_PORTAL_GET_CONTRACTS_BY_USER_ID, "/").concat(userId),
                            payLoad: {},
                            showLoader: true,
                        })];
                case 1:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        apiResponse = response.data;
                        rawData = apiResponse.data;
                        contracts_1 = Array.isArray(rawData) ? rawData : [];
                        setUserContractData(contracts_1);
                        if (contracts_1.length > 0) {
                            allContractIds = contracts_1
                                .map(function (c) { var _a; return (_a = c.AspireOId) !== null && _a !== void 0 ? _a : c.aspireOId; })
                                .filter(function (id) { return id != null && id !== ""; });
                            setSelectedUserContractIds(allContractIds);
                        }
                        else {
                            setSelectedUserContractIds([]);
                        }
                    }
                    else {
                        setUserContractData([]);
                        setSelectedUserContractIds([]);
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "No contract data found for this user", constants.TOAST_TYPES.INFO);
                    }
                    return [3, 4];
                case 2:
                    error_4 = _d.sent();
                    console.error("Error fetching user contract data:", error_4);
                    setUserContractData([]);
                    setSelectedUserContractIds([]);
                    errorMessage = ((_c = (_b = error_4 === null || error_4 === void 0 ? void 0 : error_4.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_4 === null || error_4 === void 0 ? void 0 : error_4.message) ||
                        "Failed to fetch user contract data";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 4];
                case 3: return [7];
                case 4: return [2];
            }
        });
    }); };
    var tableActionHandler = function (rowData, actionType) {
        if (actionType === "Edit") {
            if (!cpPermissions.editUser.canEdit) {
                utility.alert("You do not have permission to edit users", constants.TOAST_TYPES.ERROR);
                return;
            }
            handleEditUser(rowData.Id);
        }
        else if (actionType === "Delete") {
        }
        else if (actionType === "AssociateAccount") {
            if (!cpPermissions.associateAccount.canCreate) {
                utility.alert("You do not have permission to associate accounts", constants.TOAST_TYPES.ERROR);
                return;
            }
            setSelectedUser(rowData);
            setAssociateDrawerOpen(true);
            fetchUserContractData(rowData.Id);
        }
        else if (actionType === "ViewDetails") {
            handleViewUser(rowData.Id);
        }
        else if (actionType === "VerifyPhone") {
            if (!cpPermissions.editUser.canEdit) {
                utility.alert("You do not have permission to update phone details", constants.TOAST_TYPES.ERROR);
                return;
            }
            var knownPhone = (rowData.PhoneNumber || "").replace(/\D/g, "");
            setPhoneVerifyModal({
                rowId: rowData.Id,
                name: rowData.Name,
                knownPhone: knownPhone,
                isVerified: !!rowData.IsPhoneVerified,
                stage: knownPhone ? "confirm" : "newNumber",
                confirmInput: "",
                mismatch: false,
                sameNumberError: false,
                newPhoneInput: "",
                newNumberError: false,
                submitting: false,
            });
        }
        else if (actionType === "Impersonate") {
            if (!cpPermissions.impersonate.canView) {
                utility.alert("You do not have permission to impersonate users", constants.TOAST_TYPES.ERROR);
                return;
            }
            handleImpersonateUser(rowData.Id);
        }
        else if (actionType === "Deactivate" || actionType === "Activate") {
            if (!cpPermissions.deactivateUser.canEdit) {
                utility.alert("You do not have permission to deactivate/activate users", constants.TOAST_TYPES.ERROR);
                return;
            }
            var currentStatus = rowData.Status;
            var newStatus = currentStatus === 1 ? 0 : 1;
            setPendingStatusUpdate({ userId: rowData.Id, newStatus: newStatus, actionType: actionType });
            setStatusConfirmationOpen(true);
        }
    };
    var handleCloseAssociateDrawer = function () {
        setAssociateDrawerOpen(false);
        setSelectedUser(null);
        setAssociateSearchText("");
        setSearchedUsers([]);
        setSelectedUserForContracts([]);
        setSelectedContractIds([]);
        setContracts([]);
        setUserContractData([]);
        setSelectedUserContractIds([]);
        setIsContractChecked(false);
    };
    var handleContractToggle = function (contractId) {
        setSelectedContractIds(function (prev) {
            if (prev.includes(contractId)) {
                return prev.filter(function (selectedId) { return selectedId !== contractId; });
            }
            else {
                return __spreadArray(__spreadArray([], prev, true), [contractId], false);
            }
        });
    };
    var searchUsersForAssociation = function (searchText) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, apiResponse, error_5;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!searchText || searchText.length < 3) {
                        setSearchedUsers([]);
                        return [2];
                    }
                    if (!selctedPortal) {
                        utility.alert("Please select a portal first", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    setIsSearchingUsers(true);
                    payload = {
                        searchTerm: searchText,
                        portalId: selctedPortal,
                        aspireOIds: selectedUserContractIds,
                    };
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4, api_service.post({
                            endPoint: api_urls.CUSTOMER_PORTAL_SEARCH_USER,
                            payLoad: payload,
                            showLoader: false,
                        })];
                case 2:
                    response = _c.sent();
                    if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                        apiResponse = response.data;
                        if ((_b = apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.data) === null || _b === void 0 ? void 0 : _b.data) {
                            setSearchedUsers(apiResponse.data.data);
                        }
                        else {
                            setSearchedUsers([]);
                        }
                    }
                    else {
                        setSearchedUsers([]);
                    }
                    return [3, 5];
                case 3:
                    error_5 = _c.sent();
                    console.error("Error searching users:", error_5);
                    setSearchedUsers([]);
                    return [3, 5];
                case 4:
                    setIsSearchingUsers(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    var fetchContractsByUserId = function (aspireOId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, apiResponse, error_6, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!selctedPortal) {
                        utility.alert("Please select a portal first", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    setContracts([]);
                    setSelectedContractIds([]);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    return [4, api_service.get({
                            endPoint: api_urls.CUTOMER_PORTAL_BOOKED_CONTRACTS,
                            payLoad: {
                                aspireOId: aspireOId,
                                portalId: selctedPortal,
                            },
                            showLoader: true,
                        })];
                case 2:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        apiResponse = response.data;
                        setContracts(apiResponse.data || []);
                    }
                    else {
                        setContracts([]);
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "No contracts found for this user", constants.TOAST_TYPES.INFO);
                    }
                    return [3, 5];
                case 3:
                    error_6 = _d.sent();
                    console.error("Error fetching contracts:", error_6);
                    setContracts([]);
                    errorMessage = ((_c = (_b = error_6 === null || error_6 === void 0 ? void 0 : error_6.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_6 === null || error_6 === void 0 ? void 0 : error_6.message) ||
                        "Failed to fetch contracts";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 5];
                case 4: return [7];
                case 5: return [2];
            }
        });
    }); };
    var handleSelectUserForContracts = function (user) {
        setSelectedUserForContracts(function (prev) {
            var alreadySelected = prev.some(function (u) { return u.CustomerAspireOId === user.CustomerAspireOId; });
            return alreadySelected ? prev : __spreadArray(__spreadArray([], prev, true), [user], false);
        });
        setSearchedUsers([]);
        setAssociateSearchText("");
        fetchContractsByUserId(user.CustomerAspireOId);
    };
    var handleAssociateUsers = function () { return __awaiter(void 0, void 0, void 0, function () {
        var idsToUnlink_1, associationIds, payload, response, error_7, errorMessage, payload, response, error_8, errorMessage;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!selectedUser) {
                        utility.alert("Please select a Account", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    if (!isContractChecked) return [3, 5];
                    idsToUnlink_1 = selectedUserContractIds
                        .map(function (id) { return (id != null && id !== "" ? String(id) : null); })
                        .filter(function (id) { return id != null; });
                    if (idsToUnlink_1.length === 0) {
                        utility.alert("Please select at least one account to unlink.", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    if (idsToUnlink_1.length === userContractData.length) {
                        utility.alert("At least one account must remain associated with the user.", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, , 4]);
                    associationIds = userContractData
                        .filter(function (c) {
                        var _a;
                        var oid = (_a = c.AspireOId) !== null && _a !== void 0 ? _a : c.aspireOId;
                        var oidStr = oid != null && oid !== "" ? String(oid) : "";
                        return oidStr && idsToUnlink_1.includes(oidStr);
                    })
                        .map(function (c) { return c.Id; })
                        .filter(function (id) { return id != null && id !== ""; });
                    payload = {
                        userId: Number(selectedUser.Id),
                        aspireUserIds: idsToUnlink_1,
                    };
                    if (associationIds.length > 0) {
                        payload.associationIds = associationIds;
                    }
                    return [4, api_service.post({
                            endPoint: api_urls.CUSTOMER_PORTAL_UNLINK_ASSOCIATE_USERS,
                            payLoad: payload,
                            showLoader: true,
                        })];
                case 2:
                    response = _g.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        utility.alert(response.data.message || "Account unassociated successfully!", constants.TOAST_TYPES.INFO);
                        handleCloseAssociateDrawer();
                        fetchUsers(currentPage, recordsPerPage);
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to unassociate Account", constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 4];
                case 3:
                    error_7 = _g.sent();
                    console.error("Error unassociating Accounts:", error_7);
                    errorMessage = ((_c = (_b = error_7 === null || error_7 === void 0 ? void 0 : error_7.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_7 === null || error_7 === void 0 ? void 0 : error_7.message) ||
                        "Failed to unassociate Accounts";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 4];
                case 4: return [2];
                case 5:
                    if (!selectedUserForContracts) {
                        utility.alert("Please select a account", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    if (selectedUserForContracts.length === 0) {
                        utility.alert("Please select at least one account to associate. Account selection is mandatory.", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    _g.label = 6;
                case 6:
                    _g.trys.push([6, 8, , 9]);
                    payload = {
                        userId: Number(selectedUser.Id),
                        userDetails: selectedUserForContracts.map(function (user) {
                            var _a;
                            return ({
                                aspireOId: Number(user.CustomerAspireOId),
                                accountType: (_a = user.AccountType) !== null && _a !== void 0 ? _a : "I",
                                aspireRecordId: user.ContractId,
                                aspireId: user.CustomerAspireId,
                                firstName: user.FirstName,
                                lastName: user.LastName,
                                name: user.Name,
                                legalName: user.LegalRegisteredName,
                                email: user.Email,
                                street: user.MainAddress,
                                city: user.City,
                                state: user.State,
                                country: user.Country,
                                postalCode: user.PostalCode,
                            });
                        }),
                    };
                    return [4, api_service.post({
                            endPoint: api_urls.CUSTOMER_PORTAL_LINK_ASSOCIATE_USERS,
                            payLoad: payload,
                            showLoader: true,
                        })];
                case 7:
                    response = _g.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        utility.alert(response.data.message || "Contracts associated successfully!", constants.TOAST_TYPES.INFO);
                        handleCloseAssociateDrawer();
                        fetchUsers(currentPage, recordsPerPage);
                    }
                    else {
                        utility.alert(((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.message) || "Failed to associate contracts", constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 9];
                case 8:
                    error_8 = _g.sent();
                    console.error("Error associating contracts:", error_8);
                    errorMessage = ((_f = (_e = error_8 === null || error_8 === void 0 ? void 0 : error_8.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.message) ||
                        (error_8 === null || error_8 === void 0 ? void 0 : error_8.message) ||
                        "Failed to associate contracts";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 9];
                case 9: return [2];
            }
        });
    }); };
    useEffect(function () {
        if (associateDrawerOpen && associateSearchText) {
            var timer_1 = setTimeout(function () {
                searchUsersForAssociation(associateSearchText);
            }, 500);
            return function () { return clearTimeout(timer_1); };
        }
        else if (associateDrawerOpen && !associateSearchText) {
            setSearchedUsers([]);
        }
    }, [associateSearchText, associateDrawerOpen]);
    var fetchUserData = function (userId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, userData, statusText, statusValue, statusLower, registeredOnDate, momentDate, error_9, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, 3, 4]);
                    return [4, api_service.get({
                            endPoint: "".concat(api_urls.CUSTOMER_PORTAL_GET_USER_DATA, "/").concat(userId),
                            payLoad: {},
                            showLoader: true,
                        })];
                case 1:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        userData = response.data.data;
                        statusText = "Inactive";
                        statusValue = userData.Status;
                        if (typeof statusValue === "string") {
                            statusLower = statusValue.toLowerCase().trim();
                            if (statusLower === "active") {
                                statusText = "Active";
                            }
                            else if (statusLower === "inactive") {
                                statusText = "Inactive";
                            }
                        }
                        else if (statusValue === 1 || statusValue === true) {
                            statusText = "Active";
                        }
                        else if (statusValue === 0 ||
                            statusValue === "0" ||
                            statusValue === false) {
                            statusText = "Inactive";
                        }
                        registeredOnDate = "";
                        if (userData.RegisteredOn) {
                            registeredOnDate = userData.RegisteredOn;
                        }
                        else if (userData.CreatedTime) {
                            registeredOnDate = userData.CreatedTime;
                        }
                        else if (userData.createdTime) {
                            registeredOnDate = userData.createdTime;
                        }
                        else if (userData.registeredOn) {
                            registeredOnDate = userData.registeredOn;
                        }
                        if (registeredOnDate) {
                            try {
                                momentDate = moment(registeredOnDate);
                                if (momentDate.isValid()) {
                                    registeredOnDate = momentDate.format("YYYY-MM-DD");
                                }
                            }
                            catch (e) {
                                console.warn("Date formatting failed:", e);
                            }
                        }
                        setUserFormData({
                            FirstName: userData.FirstName || "",
                            LastName: userData.LastName || "",
                            Email: userData.Email || "",
                            phoneNumbers: userData.phoneNumbers || [],
                            Status: statusText,
                            RegisteredOn: registeredOnDate,
                        });
                        return [2, userData];
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to fetch user data", constants.TOAST_TYPES.ERROR);
                        return [2, null];
                    }
                    return [3, 4];
                case 2:
                    error_9 = _d.sent();
                    console.error("Error fetching user data:", error_9);
                    errorMessage = ((_c = (_b = error_9 === null || error_9 === void 0 ? void 0 : error_9.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_9 === null || error_9 === void 0 ? void 0 : error_9.message) ||
                        "Failed to fetch user data";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [2, null];
                case 3: return [7];
                case 4: return [2];
            }
        });
    }); };
    var handleEditUser = function (userId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSelectedUserId(userId);
                    setEditDrawerOpen(true);
                    return [4, fetchUserData(userId)];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var handleViewUser = function (userId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSelectedUserId(userId);
                    setViewDrawerOpen(true);
                    return [4, fetchUserData(userId)];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var handleImpersonateUser = function (userId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, token, selectedBrand, portalUrl, customerPortalUrl, error_10, errorMessage;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 2, , 3]);
                    return [4, api_service.get({
                            endPoint: "".concat(api_urls.CUSTOMER_PORTAL_USER_IMPERSONATE, "/").concat(userId),
                            payLoad: {},
                            showLoader: true,
                        })];
                case 1:
                    response = _g.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        token = ((_a = response.data.data) === null || _a === void 0 ? void 0 : _a.token) ||
                            ((_b = response.data.data) === null || _b === void 0 ? void 0 : _b.Token) ||
                            ((_c = response.data.data) === null || _c === void 0 ? void 0 : _c.accessToken);
                        if (token) {
                            localStorage.setItem("impersonateToken", token);
                            selectedBrand = brands.find(function (brand) { return Number(brand.Id) === selctedPortal; });
                            portalUrl = selectedBrand === null || selectedBrand === void 0 ? void 0 : selectedBrand.PortalUrl;
                            if (portalUrl) {
                                customerPortalUrl = "".concat(portalUrl, "/contracts?token=").concat(encodeURIComponent(token));
                                console.log("🔐 Impersonate URL generated:", customerPortalUrl);
                                window.open(customerPortalUrl, "_blank");
                            }
                            else {
                                utility.alert("Portal URL not found. Please select a portal first.", constants.TOAST_TYPES.ERROR);
                                return [2];
                            }
                            utility.alert(response.data.message ||
                                "User impersonation initiated successfully!", constants.TOAST_TYPES.INFO);
                        }
                        else {
                            utility.alert("Token not found in API response", constants.TOAST_TYPES.ERROR);
                        }
                    }
                    else {
                        utility.alert(((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.message) || "Failed to impersonate user", constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 3];
                case 2:
                    error_10 = _g.sent();
                    console.error("Error impersonating user:", error_10);
                    errorMessage = ((_f = (_e = error_10 === null || error_10 === void 0 ? void 0 : error_10.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.message) ||
                        (error_10 === null || error_10 === void 0 ? void 0 : error_10.message) ||
                        "Failed to impersonate user";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var handleCloseEditDrawer = function () {
        setEditDrawerOpen(false);
        setSelectedUserId(null);
        setEditFormErrors({ FirstName: "", LastName: "" });
        setUserFormData({
            FirstName: "",
            LastName: "",
            Email: "",
            phoneNumbers: [],
            Status: "",
            RegisteredOn: "",
        });
    };
    var handleCloseViewDrawer = function () {
        setViewDrawerOpen(false);
        setSelectedUserId(null);
        setUserFormData({
            FirstName: "",
            LastName: "",
            Email: "",
            phoneNumbers: [],
            Status: "",
            RegisteredOn: "",
        });
    };
    var handleSaveUser = function () { return __awaiter(void 0, void 0, void 0, function () {
        var firstNameError, lastNameError, payload, response, error_11, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!selectedUserId)
                        return [2];
                    firstNameError = validateNameField(userFormData.FirstName, "First Name");
                    lastNameError = validateNameField(userFormData.LastName, "Last Name");
                    if (firstNameError || lastNameError) {
                        setEditFormErrors({ FirstName: firstNameError, LastName: lastNameError });
                        return [2];
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    payload = {
                        firstName: userFormData.FirstName,
                        lastName: userFormData.LastName,
                    };
                    return [4, api_service.patch({
                            endPoint: "".concat(api_urls.CUSTOMER_PORTAL_UPDATE_USER, "/").concat(selectedUserId),
                            payLoad: payload,
                            showLoader: true,
                        })];
                case 2:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        utility.alert(response.data.message || "User updated successfully!", constants.TOAST_TYPES.INFO);
                        handleCloseEditDrawer();
                        fetchUsers(currentPage, recordsPerPage);
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to update user", constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 4];
                case 3:
                    error_11 = _d.sent();
                    console.error("Error updating user:", error_11);
                    errorMessage = ((_c = (_b = error_11 === null || error_11 === void 0 ? void 0 : error_11.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_11 === null || error_11 === void 0 ? void 0 : error_11.message) ||
                        "Failed to update user";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var closePhoneVerifyModal = function () { return setPhoneVerifyModal(null); };
    var handlePhoneConfirmInputChange = function (val) {
        if (!phoneVerifyModal)
            return;
        setPhoneVerifyModal(__assign(__assign({}, phoneVerifyModal), { confirmInput: val.replace(/\D/g, "").slice(0, 10), mismatch: false, sameNumberError: false }));
    };
    var handlePhoneTryAgain = function () {
        if (!phoneVerifyModal)
            return;
        setPhoneVerifyModal(__assign(__assign({}, phoneVerifyModal), { confirmInput: "", mismatch: false, sameNumberError: false }));
    };
    var handlePhoneEnterDifferentNumber = function () {
        if (!phoneVerifyModal)
            return;
        setPhoneVerifyModal(__assign(__assign({}, phoneVerifyModal), { stage: "newNumber", newPhoneInput: "", confirmInput: "", mismatch: false, sameNumberError: false, newNumberError: false }));
    };
    var handleNewPhoneInputChange = function (val) {
        if (!phoneVerifyModal)
            return;
        setPhoneVerifyModal(__assign(__assign({}, phoneVerifyModal), { newPhoneInput: val.replace(/\D/g, "").slice(0, 10), newNumberError: false, sameNumberError: false }));
    };
    var verifyExistingPhone = function (phoneNumber) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_12, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!phoneVerifyModal)
                        return [2];
                    setPhoneVerifyModal(__assign(__assign({}, phoneVerifyModal), { submitting: true }));
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4, api_service.patch({
                            endPoint: api_urls.CUSTOMER_PORTAL_VERIFY_PHONE_NUMBER,
                            payLoad: { userId: phoneVerifyModal.rowId, phoneNumber: phoneNumber },
                            showLoader: true,
                        })];
                case 2:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        utility.alert(response.data.message || "Phone number verified successfully!", constants.TOAST_TYPES.INFO);
                        closePhoneVerifyModal();
                        fetchUsers(currentPage, recordsPerPage);
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to verify phone number", constants.TOAST_TYPES.ERROR);
                        setPhoneVerifyModal(function (prev) {
                            return prev ? __assign(__assign({}, prev), { submitting: false }) : prev;
                        });
                    }
                    return [3, 4];
                case 3:
                    error_12 = _d.sent();
                    console.error("Error verifying phone number:", error_12);
                    errorMessage = ((_c = (_b = error_12 === null || error_12 === void 0 ? void 0 : error_12.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_12 === null || error_12 === void 0 ? void 0 : error_12.message) ||
                        "Failed to verify phone number";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    setPhoneVerifyModal(function (prev) {
                        return prev ? __assign(__assign({}, prev), { submitting: false }) : prev;
                    });
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var updatePhoneNumber = function (phoneNumber) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_13, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!phoneVerifyModal)
                        return [2];
                    setPhoneVerifyModal(__assign(__assign({}, phoneVerifyModal), { submitting: true }));
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4, api_service.patch({
                            endPoint: api_urls.CUSTOMER_PORTAL_UPDATE_PHONE_NUMBER,
                            payLoad: {
                                userId: phoneVerifyModal.rowId,
                                phoneNumber: phoneNumber,
                                phoneExtension: PHONE_EXTENSION,
                            },
                            showLoader: true,
                        })];
                case 2:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        utility.alert(response.data.message ||
                            "Phone number updated and verified successfully!", constants.TOAST_TYPES.INFO);
                        closePhoneVerifyModal();
                        fetchUsers(currentPage, recordsPerPage);
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to update phone number", constants.TOAST_TYPES.ERROR);
                        setPhoneVerifyModal(function (prev) {
                            return prev ? __assign(__assign({}, prev), { submitting: false }) : prev;
                        });
                    }
                    return [3, 4];
                case 3:
                    error_13 = _d.sent();
                    console.error("Error updating phone number:", error_13);
                    errorMessage = ((_c = (_b = error_13 === null || error_13 === void 0 ? void 0 : error_13.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_13 === null || error_13 === void 0 ? void 0 : error_13.message) ||
                        "Failed to update phone number";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    setPhoneVerifyModal(function (prev) {
                        return prev ? __assign(__assign({}, prev), { submitting: false }) : prev;
                    });
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var handlePhoneContinue = function () {
        if (!phoneVerifyModal || !isValidPhoneDigits(phoneVerifyModal.confirmInput))
            return;
        if (phoneVerifyModal.isVerified) {
            if (phoneVerifyModal.confirmInput === phoneVerifyModal.knownPhone) {
                setPhoneVerifyModal(__assign(__assign({}, phoneVerifyModal), { sameNumberError: true, mismatch: false }));
                return;
            }
            updatePhoneNumber(phoneVerifyModal.confirmInput);
            return;
        }
        if (phoneVerifyModal.confirmInput !== phoneVerifyModal.knownPhone) {
            setPhoneVerifyModal(__assign(__assign({}, phoneVerifyModal), { mismatch: true, sameNumberError: false }));
            return;
        }
        verifyExistingPhone(phoneVerifyModal.confirmInput);
    };
    var handleUpdateAndVerifyPhone = function () {
        if (!phoneVerifyModal ||
            !isValidPhoneDigits(phoneVerifyModal.newPhoneInput)) {
            if (phoneVerifyModal) {
                setPhoneVerifyModal(__assign(__assign({}, phoneVerifyModal), { newNumberError: true, sameNumberError: false }));
            }
            return;
        }
        if (phoneVerifyModal.knownPhone &&
            phoneVerifyModal.newPhoneInput === phoneVerifyModal.knownPhone) {
            setPhoneVerifyModal(__assign(__assign({}, phoneVerifyModal), { sameNumberError: true, newNumberError: false }));
            return;
        }
        updatePhoneNumber(phoneVerifyModal.newPhoneInput);
    };
    var handleConfirmStatusUpdate = function () {
        if (pendingStatusUpdate) {
            updateUserStatus(pendingStatusUpdate.userId, {
                Status: pendingStatusUpdate.newStatus,
            });
            setStatusConfirmationOpen(false);
            setPendingStatusUpdate(null);
        }
    };
    var handleSelectPortal = function (event) {
        setSelectedPortal(Number(event.target.value));
        setCurrentPage(1);
    };
    var handleCancelStatusUpdate = function () {
        setStatusConfirmationOpen(false);
        setPendingStatusUpdate(null);
    };
    var fetchUserNotificationData = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, userNotificationData_1, error_14, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    payload = {
                        fromDate: "",
                        toDate: "",
                    };
                    if (fromDate) {
                        payload.fromDate = moment(fromDate).format("YYYY-MM-DD");
                    }
                    if (toDate) {
                        payload.toDate = moment(toDate).format("YYYY-MM-DD");
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4, api_service.get({
                            endPoint: "".concat(api_urls.CUSTOMER_PORTAL_GET_USER_NOTIFICATION_DATA, "/").concat(id),
                            payLoad: payload,
                            showLoader: true,
                        })];
                case 2:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        userNotificationData_1 = response.data.data;
                        setUserNotificationData(userNotificationData_1);
                        setRowDataScreen(true);
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to fetch user notification data", constants.TOAST_TYPES.ERROR);
                        return [2, null];
                    }
                    return [3, 4];
                case 3:
                    error_14 = _d.sent();
                    console.error("Error fetching user notification data:", error_14);
                    errorMessage = ((_c = (_b = error_14 === null || error_14 === void 0 ? void 0 : error_14.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_14 === null || error_14 === void 0 ? void 0 : error_14.message) ||
                        "Failed to fetch user notification data";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var handleRowClickHandler = function (rowData) {
        var _a, _b;
        setUserName(rowData.Name);
        setUserEmail(rowData.Email);
        setUserCustomerId((_a = rowData.AspireId) !== null && _a !== void 0 ? _a : "-");
        setUserPhone((_b = rowData.PhoneNumber) !== null && _b !== void 0 ? _b : null);
        setUserPhoneVerified(!!rowData.IsPhoneVerified);
        setSelectedUserId(rowData.Id);
        setDetailRow(rowData);
        setNotificationCurrentPage(1);
        fetchUserNotificationData(rowData.Id);
    };
    var detailUser = useMemo(function () { var _a; return (_a = users === null || users === void 0 ? void 0 : users.find(function (u) { return u.Id === (detailRow === null || detailRow === void 0 ? void 0 : detailRow.Id); })) !== null && _a !== void 0 ? _a : detailRow; }, [users, detailRow]);
    useEffect(function () {
        if (fromDate && toDate && selectedUserId && rowDataScreen) {
            fetchUserNotificationData(selectedUserId);
        }
    }, [fromDate, toDate, rowDataScreen]);
    var filteredNotificationData = useMemo(function () {
        var data = userNotificationData;
        if (!data || !Array.isArray(data))
            return [];
        if (!fromDate || !toDate)
            return data;
        var startOfRange = moment(fromDate).startOf("day");
        var endOfRange = moment(toDate).endOf("day");
        return data.filter(function (item) {
            var created = item === null || item === void 0 ? void 0 : item.createdDate;
            if (created == null || created === "")
                return false;
            var m = moment(created);
            if (!m.isValid())
                return false;
            return m.isSameOrAfter(startOfRange) && m.isSameOrBefore(endOfRange);
        });
    }, [userNotificationData, fromDate, toDate]);
    var paginatedNotificationData = useMemo(function () {
        var data = filteredNotificationData !== null && filteredNotificationData !== void 0 ? filteredNotificationData : [];
        if (data.length === 0)
            return [];
        var start = (notificationCurrentPage - 1) * notificationRecordsPerPage;
        return data.slice(start, start + notificationRecordsPerPage);
    }, [
        filteredNotificationData,
        notificationCurrentPage,
        notificationRecordsPerPage,
    ]);
    var handleBackToList = function () {
        setRowDataScreen(false);
        setFromDate(moment().subtract(6, "days").format("YYYY-MM-DD"));
        setToDate(moment().format("YYYY-MM-DD"));
    };
    return (React.createElement(Stack, { sx: { p: 3, minHeight: "calc(100dvh - 200px)", gap: 1.5 } },
        rowDataScreen ? (React.createElement(Box, null,
            React.createElement(Stack, { direction: "row", alignItems: "end", justifyContent: "space-between", mb: 2, gap: 2 },
                React.createElement(Stack, { direction: "row", gap: 2, alignItems: "center" },
                    React.createElement(IconButton, { sx: {
                            bgcolor: colors.creamPreset[20],
                            borderRadius: "50%",
                            cursor: "pointer",
                            "&:hover": {
                                bgcolor: colors.creamPreset[20],
                            },
                        }, onClick: handleBackToList },
                        React.createElement(BackArrowIcon, null)),
                    React.createElement(Stack, null,
                        React.createElement(Typography, { variant: "body2", color: "textSecondary" },
                            React.createElement(Typography, { variant: "body2", component: "span", color: "textPrimary", mr: 0.5, fontWeight: 600 }, "User Name :"),
                            userName,
                            detailUser && (React.createElement(Typography, { variant: "caption", component: "span", sx: {
                                    ml: 1.5,
                                    px: 1,
                                    py: 0.25,
                                    borderRadius: "6px",
                                    fontWeight: 500,
                                    color: detailUser.Status === 1 ? "#057A55" : "#C81E1E",
                                    bgcolor: detailUser.Status === 1 ? "#DEF7EC" : "#FDE8E8",
                                } }, detailUser.Status === 1 ? "Active" : "Inactive"))),
                        React.createElement(Typography, { variant: "body2", color: "textSecondary" },
                            React.createElement(Typography, { variant: "body2", component: "span", color: "textPrimary", mr: 0.5, fontWeight: 600 }, "Email :"),
                            userEmail),
                        React.createElement(Typography, { variant: "body2", color: "textSecondary" },
                            React.createElement(Typography, { variant: "body2", component: "span", color: "textPrimary", mr: 0.5, fontWeight: 600 }, "Phone :"),
                            userPhone ? (React.createElement(React.Fragment, null,
                                maskPhoneNumber(userPhone),
                                " · ",
                                React.createElement(Typography, { variant: "body2", component: "span", color: userPhoneVerified ? "#057A55" : "#B54708" }, userPhoneVerified ? "Verified" : "Unverified"))) : ("— · Not set"),
                            (detailUser === null || detailUser === void 0 ? void 0 : detailUser.Status) === 1 && (React.createElement(Button, { variant: "outlined", size: "small", sx: { ml: 1.5, py: 0, minHeight: 24, fontSize: 12 }, onClick: function () { return tableActionHandler(detailUser, "VerifyPhone"); } }, getPhoneActionLabel(detailUser.PhoneNumber, detailUser.IsPhoneVerified)))),
                        React.createElement(Typography, { variant: "body2", color: "textSecondary" },
                            React.createElement(Typography, { variant: "body2", component: "span", color: "textPrimary", mr: 0.5, fontWeight: 600 }, "Customer ID :"),
                            userCustomerId))),
                React.createElement(Stack, { direction: "row", gap: 2 },
                    React.createElement(Box, { sx: {
                            minWidth: 180,
                            "& .MuiInputBase-root": { bgcolor: "#fff" },
                        } },
                        React.createElement(MUIDatePicker, { labelText: "Start Date", isMandatory: false, selectedDate: fromDate, maxDate: toDate || undefined, errorMessage: "", dateChangeHandler: function (date) {
                                if (date == null || date === "") {
                                    setFromDate("");
                                    setToDateError("");
                                    return;
                                }
                                var dateValidation = validateDate(date);
                                if (!dateValidation.isValid) {
                                    utility.alert(dateValidation.errorMessage, constants.TOAST_TYPES.ERROR);
                                    return;
                                }
                                var formattedDate = moment(date).format("YYYY-MM-DD");
                                if (!formattedDate || formattedDate === "Invalid date") {
                                    utility.alert("Invalid date format", constants.TOAST_TYPES.ERROR);
                                    return;
                                }
                                if (toDate &&
                                    moment(formattedDate).isAfter(moment(toDate))) {
                                    utility.alert("Start date cannot be after end date.", constants.TOAST_TYPES.ERROR);
                                    return;
                                }
                                setFromDate(formattedDate);
                                setNotificationCurrentPage(1);
                            } })),
                    React.createElement(Box, { sx: {
                            minWidth: 180,
                            "& .MuiInputBase-root": { bgcolor: "#fff" },
                        } },
                        React.createElement(MUIDatePicker, { key: "notification-end-".concat(fromDate, "-").concat(toDate), labelText: "End Date", isMandatory: false, selectedDate: toDate, minDate: fromDate || undefined, errorMessage: "", dateChangeHandler: function (date) {
                                if (date == null || date === "") {
                                    setToDate("");
                                    setFromDateError("");
                                    return;
                                }
                                var dateValidation = validateDate(date);
                                if (!dateValidation.isValid) {
                                    utility.alert(dateValidation.errorMessage, constants.TOAST_TYPES.ERROR);
                                    return;
                                }
                                var formattedDate = moment(date).format("YYYY-MM-DD");
                                if (!formattedDate || formattedDate === "Invalid date") {
                                    utility.alert("Invalid date format", constants.TOAST_TYPES.ERROR);
                                    return;
                                }
                                if (formattedDate &&
                                    fromDate &&
                                    moment(formattedDate).isBefore(moment(fromDate))) {
                                    utility.alert("End date cannot be before start date.", constants.TOAST_TYPES.ERROR);
                                    return;
                                }
                                setToDate(formattedDate);
                                setNotificationCurrentPage(1);
                            } })))),
            React.createElement(Box, { className: "common-module-wrapper" },
                React.createElement(Box, { className: "module-common-table-wrapper" },
                    React.createElement(ModuleTable, { dataToDisplay: paginatedNotificationData, columns: CustomerPortalUserNotificationCols, isLoading: isLoading, isRowClickEnabled: true, actionHandler: tableActionHandler, moduleName: "Customer Portal User Management", isPortalSelected: true, hideEditIcon: true, useCustomerPortalMenu: true, activePage: notificationCurrentPage, recordsPerPage: notificationRecordsPerPage, setActivePage: setNotificationCurrentPage, setRecordsPerPage: setNotificationRecordsPerPage, totalNumberOfRecords: (_a = filteredNotificationData === null || filteredNotificationData === void 0 ? void 0 : filteredNotificationData.length) !== null && _a !== void 0 ? _a : 0, customerPoratl: true, isActionColumn: false, tableContainerMaxHeight: "calc(100dvh - 310px)", hidePagination: true }))))) : (React.createElement(Box, null,
            React.createElement(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center" },
                React.createElement(CommonHeader, { mainTitle: "Customer Management", subTitle: "Manage customers, and access permissions.", icon: React.createElement(CustomerPortalUsermanagementIcon, { sx: { svg: { height: 24, width: 24 }, height: 24 } }) }),
                React.createElement(Stack, { direction: "row", alignItems: "center", gap: 2 },
                    React.createElement(Box, null,
                        React.createElement(FormControl, { size: "small", sx: { minWidth: 164 } },
                            React.createElement(Select, { value: selctedPortal || "", sx: {
                                    borderRadius: "8px",
                                    bgcolor: "#fff",
                                    height: 36,
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#a3a9b9",
                                    },
                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#a3a9b9",
                                    },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#a3a9b9",
                                        borderWidth: "1px",
                                    },
                                }, onChange: handleSelectPortal, displayEmpty: true }, brands.map(function (brand) { return (React.createElement(MenuItem, { key: brand.Id, value: Number(brand.Id) }, getCustomerPortalDisplayName(brand.PortalName))); })))),
                    React.createElement(Box, { sx: { minWidth: 300, maxWidth: 400 } },
                        React.createElement(SearchField, { value: searchText, onSearch: handleSearch, placeholder: "Search by Name/Email/Customer ID", debounceTimer: 500 })))),
            React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "end", mb: 1 },
                React.createElement(Checkbox, { checked: showInactiveOnly, onChange: function (e) { return setShowInactiveOnly(e.target.checked); } }),
                React.createElement(Typography, { variant: "body1" }, "Check this box for deactivated users")),
            React.createElement(Box, { className: "common-module-wrapper" },
                React.createElement(Box, { className: "module-common-table-wrapper", sx: { margin: "0px !important" } },
                    React.createElement(ModuleTable, { dataToDisplay: users, columns: CustomerPortalUserManagementCols, isLoading: isLoading, isRowClickEnabled: true, onClickHandler: handleRowClickHandler, actionHandler: tableActionHandler, moduleName: "Customer Portal User Management", isPortalSelected: true, hideEditIcon: true, useCustomerPortalMenu: true, showImpersonate: true, activePage: currentPage, recordsPerPage: recordsPerPage, setActivePage: setCurrentPage, setRecordsPerPage: setRecordsPerPage, totalNumberOfRecords: totalCount, customerPoratl: true, tableContainerMaxHeight: "calc(100dvh - 275px)", hidePagination: true }))))),
        React.createElement(Modal, { open: associateDrawerOpen, onClose: handleCloseAssociateDrawer },
            React.createElement(Box, { sx: {
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "900px",
                    maxHeight: "calc(100dvh - 80px)",
                    bgcolor: "#fff",
                    borderRadius: 2,
                    boxShadow: 24,
                    display: "flex",
                    flexDirection: "column",
                } },
                React.createElement(Box, { sx: {
                        px: 3,
                        py: 2,
                        borderBottom: "1px solid ".concat(colors.greyShades[20]),
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    } },
                    React.createElement(Typography, { fontWeight: 600, fontSize: 16 }, "Associate Account"),
                    React.createElement(CloseIcon, { onClick: handleCloseAssociateDrawer, sx: {
                            cursor: "pointer",
                            color: colors.greyShades[10],
                            height: 24,
                            width: 24,
                        } })),
                React.createElement(Box, { sx: { flex: 1, overflowY: "auto" } },
                    React.createElement(Box, { sx: { p: 3, pb: 0 } },
                        React.createElement(Box, { sx: { mb: 2 } },
                            React.createElement(Typography, { variant: "body2", color: "text.secondary" }, "User"),
                            React.createElement(Box, { sx: {
                                    p: 1,
                                    border: "1px solid ".concat(colors.greyShades[20]),
                                    borderRadius: 1,
                                    bgcolor: colors.greyShades[11],
                                } },
                                React.createElement(Typography, { fontWeight: 600, fontSize: 16 }, selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.FirstName),
                                React.createElement(Typography, { fontSize: 14, color: "textSecondary" }, selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.Email))),
                        React.createElement(Box, { sx: { mb: 2 } },
                            React.createElement(TextField, { label: "Portal URL", name: "PortalUrl", placeholder: "Portal URL", fullWidth: true, value: ((_b = brands.find(function (brand) { return Number(brand.Id) === selctedPortal; })) === null || _b === void 0 ? void 0 : _b.PortalUrl) || "", onChange: function () { }, disabled: true, type: "text" })),
                        userContractData.length === 0 ? (React.createElement(Box, { sx: { p: 2, textAlign: "center" } },
                            React.createElement(Typography, { variant: "body2", color: "text.secondary" }, "No associate accounts found for this user."))) : (React.createElement(Stack, { sx: {
                                border: "1px solid ".concat(colors.greyShades[20]),
                                borderRadius: 2,
                                bgcolor: "#fff",
                                mb: 2,
                            } },
                            React.createElement(Stack, { sx: { p: 2 } },
                                React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1 },
                                    React.createElement(Checkbox, { checked: isContractChecked, onChange: function (e) {
                                            var checked = e.target.checked;
                                            setIsContractChecked(checked);
                                            if (checked) {
                                                var allContractIds = userContractData
                                                    .map(function (c) { var _a; return (_a = c.AspireOId) !== null && _a !== void 0 ? _a : c.aspireOId; })
                                                    .filter(function (id) {
                                                    return id != null && id !== "";
                                                });
                                                setSelectedUserContractIds(allContractIds);
                                            }
                                            else {
                                                setSelectedUserContractIds([]);
                                            }
                                        }, size: "small", sx: { p: 0 } }),
                                    React.createElement(Typography, { fontWeight: 600, variant: "body2" }, "Unlink Associate Accounts")),
                                React.createElement(Typography, { variant: "body2", color: "text.secondary", sx: { ml: 4, mb: 2 } }, "Select accounts to remove from association"),
                                userContractData.length === 0 ? (React.createElement(Box, { sx: { p: 2, textAlign: "center" } },
                                    React.createElement(Typography, { variant: "body2", color: "text.secondary" }, "No accounts found for this user."))) : (React.createElement(Box, { sx: {
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        gap: 1.5,
                                    } }, userContractData.map(function (contract, index) {
                                    var _a;
                                    var contractId = (_a = contract.AspireOId) !== null && _a !== void 0 ? _a : contract.aspireOId;
                                    var idStr = contractId != null ? String(contractId) : "";
                                    var isSelected = idStr &&
                                        selectedUserContractIds.some(function (x) { return String(x) === idStr; });
                                    var aspireRecordId = contract.AspireId || "";
                                    var address = [
                                        contract.Street,
                                        contract.City,
                                        contract.State,
                                        contract.Country,
                                    ]
                                        .filter(Boolean)
                                        .join(", ");
                                    return (React.createElement(Box, { key: idStr || index, onClick: function () {
                                            if (!isContractChecked || !contractId)
                                                return;
                                            setSelectedUserContractIds(function (p) {
                                                return isSelected
                                                    ? p.filter(function (x) { return String(x) !== idStr; })
                                                    : __spreadArray(__spreadArray([], p, true), [contractId], false);
                                            });
                                        }, sx: {
                                            display: "flex",
                                            gap: 1.5,
                                            border: "1px solid ".concat(colors.greyShades[20]),
                                            borderRadius: 2,
                                            p: 1.5,
                                            cursor: isContractChecked
                                                ? "pointer"
                                                : "default",
                                            bgcolor: isSelected
                                                ? colors.greyShades[11]
                                                : "#fff",
                                            "&:hover": isContractChecked
                                                ? { bgcolor: colors.greyShades[11] }
                                                : {},
                                        } },
                                        React.createElement(Checkbox, { checked: !!isSelected, disabled: !isContractChecked, onChange: function (e) {
                                                e.stopPropagation();
                                                if (e.target.checked) {
                                                    setSelectedUserContractIds(function (p) { return __spreadArray(__spreadArray([], p, true), [
                                                        contractId,
                                                    ], false); });
                                                }
                                                else {
                                                    setSelectedUserContractIds(function (p) {
                                                        return p.filter(function (x) { return String(x) !== idStr; });
                                                    });
                                                }
                                            }, onClick: function (e) { return e.stopPropagation(); }, size: "small", sx: {
                                                p: 0,
                                                mt: 0.25,
                                                flexShrink: 0,
                                                pointerEvents: "auto",
                                            } }),
                                        React.createElement(Box, { sx: { flex: 1, minWidth: 0 } },
                                            React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", gap: 1 },
                                                React.createElement(Typography, { fontWeight: 600, fontSize: 13, noWrap: true }, contract.Name ||
                                                    "".concat(contract.LastName, ", ").concat(contract.FirstName)),
                                                aspireRecordId ? (React.createElement(Typography, { fontWeight: 600, fontSize: 13, color: "text.secondary", sx: { flexShrink: 0 } }, aspireRecordId)) : null),
                                            React.createElement(Typography, { fontSize: 12, color: "text.secondary", noWrap: true }, address || "No address found"))));
                                })))))),
                        !isContractChecked && (React.createElement(Stack, { sx: {
                                p: 2,
                                border: "1px solid ".concat(colors.greyShades[20]),
                                borderRadius: 2,
                                bgcolor: "#fff",
                                mb: 2,
                            } },
                            React.createElement(Typography, { fontWeight: 600, variant: "body2" }, "Link New Account"),
                            React.createElement(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 2 } }, "Select users to associate their account"),
                            React.createElement(MuiTextField, { fullWidth: true, size: "small", value: associateSearchText, placeholder: "Search users by Name, customer ID", onChange: function (e) { return setAssociateSearchText(e.target.value); }, disabled: isContractChecked, variant: "outlined", inputProps: { maxLength: 50 }, sx: {
                                    "& .MuiOutlinedInput-root": {
                                        bgcolor: "#fff",
                                        borderRadius: "8px",
                                        "& fieldset": { borderColor: colors.greyShades[20] },
                                        "&:hover fieldset": {
                                            borderColor: colors.greyShades[20],
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#1976d2",
                                            borderWidth: "1px",
                                        },
                                    },
                                }, InputProps: {
                                    endAdornment: (React.createElement(InputAdornment, { position: "end" },
                                        isSearchingUsers && (React.createElement(CircularProgress, { size: 20, sx: { mr: 0.5 } })),
                                        associateSearchText && !isSearchingUsers && (React.createElement(IconButton, { size: "small", onClick: function () {
                                                setAssociateSearchText("");
                                                setSearchedUsers([]);
                                            }, sx: { p: 0.5 }, "aria-label": "Clear search" },
                                            React.createElement(CloseIcon, { fontSize: "small" }))))),
                                } }))),
                        !isContractChecked &&
                            !isSearchingUsers &&
                            searchedUsers.length > 0 && (React.createElement(Box, { sx: {
                                mt: 2,
                                maxHeight: "300px",
                                overflowY: "auto",
                                border: "1px solid ".concat(colors.greyShades[20]),
                                borderRadius: 1,
                            } }, searchedUsers.map(function (user) {
                            var isSelected = selectedUserForContracts.some(function (u) { return u.CustomerAspireOId === user.CustomerAspireOId; });
                            var customerAspireId = user.CustomerAspireId || "";
                            var address = [
                                user.MainAddress,
                                user.City,
                                user.State,
                                user.Country,
                            ]
                                .filter(Boolean)
                                .join(", ");
                            return (React.createElement(Box, { key: user.CustomerAspireOId, onClick: function () {
                                    if (isSelected) {
                                        setSelectedUserForContracts(function (prev) {
                                            return prev.filter(function (u) {
                                                return u.CustomerAspireOId !==
                                                    user.CustomerAspireOId;
                                            });
                                        });
                                    }
                                    else {
                                        setSelectedUserForContracts(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
                                            user,
                                        ], false); });
                                    }
                                }, sx: {
                                    p: 2,
                                    cursor: "pointer",
                                    borderBottom: "1px solid ".concat(colors.greyShades[20]),
                                    bgcolor: isSelected
                                        ? colors.greyShades[11]
                                        : "transparent",
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: 2,
                                    "&:hover": {
                                        bgcolor: colors.greyShades[11],
                                    },
                                } },
                                React.createElement(Checkbox, { checked: isSelected, onChange: function (e) {
                                        e.stopPropagation();
                                        if (isSelected) {
                                            setSelectedUserForContracts(function (prev) {
                                                return prev.filter(function (u) {
                                                    return u.CustomerAspireOId !==
                                                        user.CustomerAspireOId;
                                                });
                                            });
                                        }
                                        else {
                                            setSelectedUserForContracts(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
                                                user,
                                            ], false); });
                                        }
                                    }, onClick: function (e) {
                                        e.stopPropagation();
                                    }, size: "small", sx: { p: 0, mt: 0.5 } }),
                                React.createElement(Box, { sx: { flex: 1 } },
                                    React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", gap: 1 },
                                        React.createElement(Typography, { fontWeight: 600, noWrap: true }, user.Name),
                                        customerAspireId ? (React.createElement(Typography, { fontWeight: 600, color: "text.secondary", sx: { flexShrink: 0 } }, customerAspireId)) : null),
                                    React.createElement(Typography, { fontSize: 12, color: "text.secondary" }, address))));
                        }))),
                        !isContractChecked &&
                            !isSearchingUsers &&
                            associateSearchText.trim().length >= 3 &&
                            searchedUsers.length === 0 && (React.createElement(Box, { sx: {
                                mt: 2,
                                mb: 2,
                                p: 3,
                                textAlign: "center",
                                border: "1px dashed ".concat(colors.greyShades[20]),
                                borderRadius: 2,
                                bgcolor: colors.greyShades[11],
                            } },
                            React.createElement(Typography, { color: "text.secondary", variant: "body2" },
                                "No users found with the name \"",
                                associateSearchText,
                                "\""),
                            React.createElement(Typography, { color: "text.secondary", variant: "caption", sx: { mt: 0.5, display: "block" } }, "Try searching with a different name"))))),
                React.createElement(Box, { sx: {
                        px: 3,
                        py: 2,
                        borderTop: "1px solid ".concat(colors.greyShades[20]),
                        display: "flex",
                        gap: 2,
                        flexDirection: "row-reverse",
                    } },
                    React.createElement(Button, { variant: "contained", onClick: handleAssociateUsers }, isContractChecked ? "Unassociate" : "Associate"),
                    React.createElement(Button, { variant: "outlined", onClick: handleCloseAssociateDrawer }, "Cancel")))),
        React.createElement(DrawerComponent, { open: editDrawerOpen, onClose: handleCloseEditDrawer, drawerTitle: "Edit User Details", drawerWidth: "450px", showTwoButtons: true, containedTitle: "Save Changes", outlinedTitle: "Cancel", onContainedClick: handleSaveUser, onOutlinedClick: handleCloseEditDrawer, swapButtonOrder: true, scrollHeight: "calc(100dvh - 140px)" },
            React.createElement(Box, { sx: { p: 3, pb: 0 } }, React.createElement(Grid, { container: true, spacing: 2 },
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement(TextField, { label: "First Name", name: "FirstName", isMandatoryField: true, placeholder: "First Name", fullWidth: true, value: userFormData.FirstName, onChange: function (e) {
                            var val = sanitizeNameFieldInput(e.target.value);
                            setUserFormData(__assign(__assign({}, userFormData), { FirstName: val }));
                            setEditFormErrors(function (prev) { return (__assign(__assign({}, prev), { FirstName: validateNameField(val, "First Name") })); });
                        }, type: "text", error: !!editFormErrors.FirstName, error_message: editFormErrors.FirstName })),
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement(TextField, { label: "Last Name", name: "LastName", isMandatoryField: true, placeholder: "Last Name", fullWidth: true, value: userFormData.LastName, onChange: function (e) {
                            var val = sanitizeNameFieldInput(e.target.value);
                            setUserFormData(__assign(__assign({}, userFormData), { LastName: val }));
                            setEditFormErrors(function (prev) { return (__assign(__assign({}, prev), { LastName: validateNameField(val, "Last Name") })); });
                        }, type: "text", error: !!editFormErrors.LastName, error_message: editFormErrors.LastName })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(TextField, { label: "Email", name: "Email", placeholder: "Email", fullWidth: true, value: userFormData.Email, onChange: function () { }, disabled: true, type: "text" })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(TextField, { label: "Phone Number", name: "PhoneNumber", placeholder: "Phone Number", fullWidth: true, value: (userFormData.phoneNumbers &&
                            userFormData.phoneNumbers.length > 0 &&
                            userFormData.phoneNumbers[0].PhoneNumber) ||
                            "", onChange: function () { }, disabled: true, type: "text", maxLength: 10, startAdornment: "+1" })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(TextField, { label: "User State", name: "Status", placeholder: "", fullWidth: true, value: userFormData.Status, onChange: function () { }, disabled: true, type: "text" })),
                React.createElement(Grid, { item: true, xs: 12, sx: {
                        "& .MuiStack-root": {
                            p: 0,
                        },
                    } },
                    React.createElement(MUIDatePicker, { labelText: "Registered On", isMandatory: false, selectedDate: userFormData.RegisteredOn, dateChangeHandler: function () { }, disabled: true }))))),
        React.createElement(DrawerComponent, { open: viewDrawerOpen, onClose: handleCloseViewDrawer, drawerTitle: "View User Details", drawerWidth: "450px", showTwoButtons: false, scrollHeight: "calc(100dvh - 80px)" },
            React.createElement(Box, { sx: { p: 3, pb: 0 } }, React.createElement(Grid, { container: true, spacing: 2 },
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement(TextField, { label: "First Name", name: "FirstName", placeholder: "First Name", fullWidth: true, value: userFormData.FirstName, onChange: function () { }, disabled: true, type: "text" })),
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement(TextField, { label: "Last Name", name: "LastName", placeholder: "Last Name", fullWidth: true, value: userFormData.LastName, onChange: function () { }, disabled: true, type: "text" })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(TextField, { label: "Email", name: "Email", placeholder: "Email", fullWidth: true, value: userFormData.Email, onChange: function () { }, disabled: true, type: "text" })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(TextField, { label: "Phone Number", name: "PhoneNumber", placeholder: "Phone Number", fullWidth: true, value: (userFormData.phoneNumbers &&
                            userFormData.phoneNumbers.length > 0 &&
                            userFormData.phoneNumbers[0].PhoneNumber) ||
                            "", onChange: function () { }, disabled: true, type: "text", maxLength: 10, startAdornment: "+1" })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(TextField, { label: "User State", name: "Status", placeholder: "", fullWidth: true, value: userFormData.Status, onChange: function () { }, disabled: true, type: "text" })),
                React.createElement(Grid, { item: true, xs: 12, sx: {
                        "& .MuiStack-root": {
                            p: 0,
                        },
                    } },
                    React.createElement(MUIDatePicker, { labelText: "Registered On", isMandatory: false, selectedDate: userFormData.RegisteredOn, dateChangeHandler: function () { }, disabled: true }))))),
        React.createElement(Modal, { open: !!phoneVerifyModal, onClose: closePhoneVerifyModal },
            React.createElement(Box, { sx: {
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "420px",
                    maxWidth: "calc(100vw - 32px)",
                    bgcolor: "#fff",
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 3.5,
                } },
                React.createElement(Stack, { direction: "row", justifyContent: "space-between", alignItems: "flex-start" },
                    React.createElement(Box, null,
                        React.createElement(Typography, { fontWeight: 800, fontSize: 19 }, getPhoneActionLabel(phoneVerifyModal === null || phoneVerifyModal === void 0 ? void 0 : phoneVerifyModal.knownPhone, phoneVerifyModal === null || phoneVerifyModal === void 0 ? void 0 : phoneVerifyModal.isVerified)),
                        React.createElement(Typography, { fontSize: 13, color: "#64748b", mt: 0.5 }, phoneVerifyModal === null || phoneVerifyModal === void 0 ? void 0 : phoneVerifyModal.name)),
                    React.createElement(CloseIcon, { onClick: closePhoneVerifyModal, sx: { cursor: "pointer", color: "#64748b" } })),
                phoneVerifyModal && (React.createElement(Box, { mt: 3 },
                    phoneVerifyModal.stage === "confirm" && (React.createElement(React.Fragment, null,
                        React.createElement(TextField, { label: "Phone Number on File", fullWidth: true, value: maskPhoneDigits(phoneVerifyModal.knownPhone), onChange: function () { }, disabled: true, type: "text", startAdornment: PHONE_EXTENSION }),
                        React.createElement(Box, { mt: 2 },
                            React.createElement(TextField, { label: phoneVerifyModal.isVerified
                                    ? "Enter New Phone Number"
                                    : "Confirm Phone Number", isMandatoryField: true, placeholder: phoneVerifyModal.isVerified
                                    ? "Enter new phone number"
                                    : "Enter the complete number", fullWidth: true, value: phoneVerifyModal.confirmInput, onChange: function (e) {
                                    return handlePhoneConfirmInputChange(e.target.value);
                                }, type: "text", maxLength: 10, startAdornment: PHONE_EXTENSION }),
                            React.createElement(Typography, { fontSize: 11, color: "#94a3b8", mt: 0.5 }, phoneVerifyModal.isVerified
                                ? "Enter a valid phone number that you want to update with existing phone number."
                                : "Enter the full registered number to continue.")),
                        !phoneVerifyModal.isVerified && phoneVerifyModal.mismatch && (React.createElement(Box, { mt: 1 },
                            React.createElement(Typography, { fontSize: 12, color: "#dc2626" }, "Registered number doesn't match. Please reset or provide the correct number."),
                            React.createElement(Stack, { direction: "row", spacing: 2, mt: 0.5 },
                                React.createElement(Button, { size: "small", sx: { textTransform: "none", p: 0, minWidth: 0 }, onClick: handlePhoneTryAgain }, "Try Again"),
                                React.createElement(Button, { size: "small", sx: { textTransform: "none", p: 0, minWidth: 0 }, onClick: handlePhoneEnterDifferentNumber }, "Enter a Different Number")))),
                        phoneVerifyModal.sameNumberError && (React.createElement(Box, { mt: 1 },
                            React.createElement(Typography, { fontSize: 12, color: "#dc2626" }, "This is the same number already on file. Enter a different number to update it."),
                            React.createElement(Button, { size: "small", sx: { textTransform: "none", p: 0, minWidth: 0, mt: 0.5 }, onClick: handlePhoneEnterDifferentNumber }, "Enter a Different Number"))))),
                    phoneVerifyModal.stage === "newNumber" && (React.createElement(React.Fragment, null,
                        React.createElement(TextField, { label: "New Phone Number", placeholder: "e.g. 4155550123", fullWidth: true, value: phoneVerifyModal.newPhoneInput, onChange: function (e) {
                                return handleNewPhoneInputChange(e.target.value);
                            }, type: "text", maxLength: 10, startAdornment: PHONE_EXTENSION, error: phoneVerifyModal.newNumberError ||
                                phoneVerifyModal.sameNumberError, error_message: phoneVerifyModal.sameNumberError
                                ? "This is the same number already on file. Enter a different number."
                                : phoneVerifyModal.newNumberError
                                    ? "Please enter a valid 10-digit phone number."
                                    : "" }),
                        React.createElement(Typography, { fontSize: 11, color: "#94a3b8", mt: 0.5 }, phoneVerifyModal.knownPhone
                            ? "Enter the new phone number. It will be updated and marked verified immediately."
                            : "Enter the phone number on the customer account. It will be saved and marked verified immediately."))))),
                React.createElement(Stack, { direction: "row", spacing: 1.5, mt: 2 },
                    React.createElement(Button, { fullWidth: true, variant: "outlined", onClick: closePhoneVerifyModal }, "Cancel"),
                    (phoneVerifyModal === null || phoneVerifyModal === void 0 ? void 0 : phoneVerifyModal.stage) === "confirm" && (React.createElement(Button, { fullWidth: true, variant: "contained", disabled: !isValidPhoneDigits(phoneVerifyModal.confirmInput) ||
                            phoneVerifyModal.submitting, onClick: handlePhoneContinue }, phoneVerifyModal.submitting ? "Verifying…" : "Continue")),
                    (phoneVerifyModal === null || phoneVerifyModal === void 0 ? void 0 : phoneVerifyModal.stage) === "newNumber" && (React.createElement(Button, { fullWidth: true, variant: "contained", disabled: !isValidPhoneDigits(phoneVerifyModal.newPhoneInput) ||
                            phoneVerifyModal.submitting, onClick: handleUpdateAndVerifyPhone }, phoneVerifyModal.submitting
                        ? "Saving…"
                        : phoneVerifyModal.knownPhone
                            ? "Update & Verify"
                            : "Add & Verify"))))),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.DELETE_CONFIRMATION_WARNING, titleText: (pendingStatusUpdate === null || pendingStatusUpdate === void 0 ? void 0 : pendingStatusUpdate.actionType) === "Deactivate"
                ? "Confirm user deactivation?"
                : "Confirm user activation?", message: (pendingStatusUpdate === null || pendingStatusUpdate === void 0 ? void 0 : pendingStatusUpdate.actionType) === "Deactivate"
                ? "Are you sure you want to deactivate this user?"
                : "Are you sure you want to activate this user?", acceptBtnText: "Yes", denyBtnText: "No", open: statusConfirmationOpen, acceptCallBack: handleConfirmStatusUpdate, denyCallBack: handleCancelStatusUpdate, cancelCallBack: handleCancelStatusUpdate, swapButtonOrder: true }),
        React.createElement(Box, { sx: { flexShrink: 0 } }, rowDataScreen ? (React.createElement(CommonTablePagination, { tableData: filteredNotificationData, setCurrentPage: setNotificationCurrentPage, setPerPageCount: setNotificationRecordsPerPage, currentPage: notificationCurrentPage, perPageCount: notificationRecordsPerPage, totalNumberOfRecords: (_c = filteredNotificationData === null || filteredNotificationData === void 0 ? void 0 : filteredNotificationData.length) !== null && _c !== void 0 ? _c : 0 })) : (React.createElement(CommonTablePagination, { tableData: users, setCurrentPage: setCurrentPage, setPerPageCount: setRecordsPerPage, currentPage: currentPage, perPageCount: recordsPerPage, totalNumberOfRecords: totalCount })))));
};
export default CustomerPortalUserManagement;
